/* ==========================================================================
   Pussy Liquor cart drawer
   - Talks to Shopify's Cart AJAX API and re-renders sections/pl-cart-drawer.liquid
     through the Section Rendering API (one round-trip per change).
   - Public API:  window.PLCart.add({ id, quantity, properties })
                  window.PLCart.change(lineKey, quantity)
                  window.PLCart.open() / .close() / .refresh()
   - Declarative: <button data-pl-add data-variant-id="123" data-quantity="1">
                  <a data-pl-cart-open>   <button data-pl-drawer-close>
   - Events:      document 'pl:cart:updated'  { detail: { count } }
   ========================================================================== */
(function () {
  'use strict';
  if (window.PLCart) return;

  var SECTION = 'pl-cart-drawer';
  var SOURCE_ID = 'pl-cart';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var lastFocus = null;
  var closeTimer = null;
  var pending = 0;

  function dialog() {
    return document.querySelector('[data-pl-drawer]');
  }
  function content() {
    return document.querySelector('[data-pl-drawer-content]');
  }
  function endpoint(path) {
    return root + path;
  }

  /* ---------- UI helpers ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-pl-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !(n > 0);
    });
    document.dispatchEvent(new CustomEvent('pl:cart:updated', { detail: { count: n } }));
  }

  function setBusy(on) {
    pending += on ? 1 : -1;
    if (pending < 0) pending = 0;
    var d = dialog();
    if (d) d.setAttribute('aria-busy', pending > 0 ? 'true' : 'false');
  }

  function showError(message) {
    var el = document.querySelector('[data-pl-drawer-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function lockScroll(on) {
    var html = document.documentElement;
    if (on) {
      html.style.setProperty('--pl-scrollbar', window.innerWidth - html.clientWidth + 'px');
      html.classList.add('pl-scroll-lock');
    } else {
      html.classList.remove('pl-scroll-lock');
      html.style.removeProperty('--pl-scrollbar');
    }
  }

  /* ---------- Open / close ---------- */
  function open() {
    var d = dialog();
    if (!d) {
      window.location.href = endpoint('cart');
      return;
    }
    clearTimeout(closeTimer);
    if (d.open) {
      d.classList.add('is-open');
      return;
    }
    lastFocus = document.activeElement;
    d.showModal();
    lockScroll(true);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        d.classList.add('is-open');
      });
    });
  }

  function close() {
    var d = dialog();
    if (!d || !d.open) return;
    d.classList.remove('is-open');
    var finish = function () {
      if (d.open) d.close();
      lockScroll(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    if (reduceMotion.matches) finish();
    else closeTimer = setTimeout(finish, 340);
  }

  /* ---------- Rendering ---------- */
  function render(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-pl-drawer-content]');
    var current = content();
    if (!next || !current) return;
    current.replaceWith(next);
    setCount(parseInt(next.dataset.count || '0', 10) || 0);
  }

  function renderFromResponse(data) {
    if (data && data.sections && data.sections[SECTION]) {
      render(data.sections[SECTION]);
      return Promise.resolve();
    }
    return refresh();
  }

  function refresh() {
    return fetch(endpoint('?sections=' + SECTION), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections && sections[SECTION]) render(sections[SECTION]);
      })
      .catch(function () {});
  }

  /* ---------- Cart API ---------- */
  function post(path, body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch(endpoint(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || 'Something went wrong. Please try again.');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function add(item) {
    var line = {
      id: Number(item.id),
      quantity: Number(item.quantity) || 1
    };
    if (item.properties) line.properties = item.properties;
    if (item.selling_plan) line.selling_plan = item.selling_plan;

    setBusy(true);
    return post('cart/add.js', line)
      .then(function (data) {
        return renderFromResponse(data);
      })
      .then(function () {
        showError('');
        open();
      })
      .catch(function (err) {
        /* e.g. "All 12 are in your cart." — show the drawer so the message is visible */
        return refresh().then(function () {
          showError(err.message);
          open();
        });
      })
      .then(function () { setBusy(false); });
  }

  function change(key, quantity) {
    setBusy(true);
    return post('cart/change.js', { id: String(key), quantity: Math.max(0, Number(quantity) || 0) })
      .then(function (data) {
        return renderFromResponse(data);
      })
      .then(function () { showError(''); })
      .catch(function (err) {
        return refresh().then(function () { showError(err.message); });
      })
      .then(function () { setBusy(false); });
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var openBtn = t.closest('[data-pl-cart-open]');
    if (openBtn) {
      e.preventDefault();
      open();
      return;
    }

    var closeBtn = t.closest('[data-pl-drawer-close]');
    if (closeBtn) {
      /* links (e.g. "Shop the collection") still navigate */
      if (closeBtn.tagName !== 'A') e.preventDefault();
      close();
      return;
    }

    /* click on the dimmed area (the <dialog> itself, outside the panel) */
    if (t.matches && t.matches('[data-pl-drawer]')) {
      close();
      return;
    }

    var qty = t.closest('[data-pl-qty]');
    if (qty) {
      e.preventDefault();
      change(qty.dataset.key, qty.dataset.plQty);
      return;
    }

    var addBtn = t.closest('[data-pl-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
      var id = addBtn.dataset.variantId;
      if (!id) return;
      addBtn.classList.add('is-loading');
      addBtn.setAttribute('aria-busy', 'true');
      add({ id: id, quantity: addBtn.dataset.quantity || 1 }).then(function () {
        addBtn.classList.remove('is-loading');
        addBtn.removeAttribute('aria-busy');
      });
    }
  });

  /* ESC → animate closed instead of snapping shut ('cancel' does not bubble, so capture) */
  document.addEventListener(
    'cancel',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-pl-drawer]')) {
        e.preventDefault();
        close();
      }
    },
    true
  );

  /* Keep in sync with the rest of the theme (e.g. product-page add to cart) */
  document.addEventListener('cart:update', function (e) {
    var detail = e.detail || {};
    if (detail.sourceId === SOURCE_ID) return;
    var fromProductForm = detail.data && detail.data.source === 'product-form-component';
    var failed = detail.data && detail.data.didError;
    refresh().then(function () {
      if (fromProductForm && !failed) open();
    });
  });

  /* Back/forward cache restore: the count in the header may be stale */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });

  window.PLCart = { add: add, change: change, open: open, close: close, refresh: refresh };
})();
